export default __webpack_public_path__ + "static/media/elevate-cbb-4.15f8b874.png";